import { FC } from "react";
import EmptySection from "./empty/EmptySection";
import TeamMembers from "./componentsWrappers/TeamMembers";
import Component from "./componentsWrappers/Component";
import { useIntl } from "react-intl";

interface TeamMembersWrapperProps {}
const TeamSCGIcon = (width = "29.689px", height = "32px") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 31 32"
    fill="none"
  >
    <path
      d="M4.91826 22.1277C6.42993 22.1277 7.66269 20.8983 7.66269 19.3832C7.66269 17.8681 6.43338 16.6388 4.91826 16.6388C3.40658 16.6388 2.17383 17.8681 2.17383 19.3832C2.17383 20.8983 3.40658 22.1277 4.91826 22.1277ZM4.91826 17.6753C5.86177 17.6753 6.62965 18.4432 6.62965 19.3867C6.62965 20.3302 5.86177 21.0981 4.91826 21.0981C3.97475 21.0981 3.20686 20.3302 3.20686 19.3867C3.20686 18.4432 3.97475 17.6753 4.91826 17.6753Z"
      fill="#9999A7"
    />
    <path
      d="M4.91827 23.4878C2.56639 23.4878 0.655273 25.4024 0.655273 27.7508V31.4835C0.655273 31.7693 0.885985 32 1.17179 32C1.4576 32 1.68831 31.7693 1.68831 31.4835V27.7508C1.68831 25.9705 3.138 24.5208 4.91827 24.5208C6.69853 24.5208 8.14822 25.9705 8.14822 27.7508V31.4835C8.14822 31.7693 8.37894 32 8.66474 32C8.95055 32 9.18126 31.7693 9.18126 31.4835V27.7508C9.1847 25.4024 7.27014 23.4878 4.91827 23.4878Z"
      fill="#9999A7"
    />
    <path
      d="M23.3374 19.3866C23.3374 20.8983 24.5667 22.1311 26.0818 22.1311C27.5935 22.1311 28.8263 20.9018 28.8263 19.3866C28.8263 17.8715 27.597 16.6422 26.0818 16.6422C24.5702 16.6422 23.3374 17.8715 23.3374 19.3866ZM26.0818 17.6752C27.0253 17.6752 27.7932 18.4431 27.7932 19.3866C27.7932 20.3301 27.0253 21.098 26.0818 21.098C25.1383 21.098 24.3704 20.3301 24.3704 19.3866C24.3704 18.4431 25.1383 17.6752 26.0818 17.6752Z"
      fill="#9999A7"
    />
    <path
      d="M26.0818 23.4878C23.73 23.4878 21.8188 25.4024 21.8188 27.7508V31.4835C21.8188 31.7693 22.0496 32 22.3354 32C22.6212 32 22.8519 31.7693 22.8519 31.4835V27.7508C22.8519 25.9705 24.3016 24.5208 26.0818 24.5208C27.8621 24.5208 29.3118 25.9705 29.3118 27.7508V31.4835C29.3118 31.7693 29.5425 32 29.8283 32C30.1141 32 30.3448 31.7693 30.3448 31.4835V27.7508C30.3448 25.4024 28.4337 23.4878 26.0818 23.4878Z"
      fill="#9999A7"
    />
    <path
      d="M12.7554 19.3866C12.7554 20.8983 13.9847 22.1311 15.4998 22.1311C17.0149 22.1311 18.2442 20.9018 18.2442 19.3866C18.2442 17.8715 17.0149 16.6422 15.4998 16.6422C13.9847 16.6422 12.7554 17.8715 12.7554 19.3866ZM15.4998 17.6752C16.4433 17.6752 17.2112 18.4431 17.2112 19.3866C17.2112 20.3301 16.4433 21.098 15.4998 21.098C14.5563 21.098 13.7884 20.3301 13.7884 19.3866C13.7884 18.4431 14.5563 17.6752 15.4998 17.6752Z"
      fill="#9999A7"
    />
    <path
      d="M15.4998 23.4878C13.1479 23.4878 11.2368 25.4024 11.2368 27.7508V31.4835C11.2368 31.7693 11.4675 32 11.7533 32C12.0391 32 12.2699 31.7693 12.2699 31.4835V27.7508C12.2699 25.9705 13.7195 24.5208 15.4998 24.5208C17.2801 24.5208 18.7298 25.9705 18.7298 27.7508V31.4835C18.7298 31.7693 18.9605 32 19.2463 32C19.5321 32 19.7628 31.7693 19.7628 31.4835V27.7508C19.7628 25.4024 17.8517 23.4878 15.4998 23.4878Z"
      fill="#9999A7"
    />
    <path
      d="M10.2107 5.48886C11.7224 5.48886 12.9552 4.25955 12.9552 2.74443C12.9552 1.23276 11.7259 0 10.2107 0C8.69562 0 7.46631 1.22931 7.46631 2.74443C7.46631 4.25611 8.69562 5.48886 10.2107 5.48886ZM10.2107 1.03304C11.1542 1.03304 11.9221 1.80093 11.9221 2.74443C11.9221 3.68794 11.1542 4.45583 10.2107 4.45583C9.26723 4.45583 8.49934 3.68794 8.49934 2.74443C8.49934 1.80093 9.26723 1.03304 10.2107 1.03304Z"
      fill="#9999A7"
    />
    <path
      d="M13.4407 11.112V14.8447C13.4407 15.1305 13.6714 15.3612 13.9572 15.3612C14.2431 15.3612 14.4738 15.1305 14.4738 14.8447V11.112C14.4738 8.76011 12.5592 6.849 10.2108 6.849C7.86234 6.849 5.94434 8.76011 5.94434 11.112V14.8447C5.94434 15.1305 6.17505 15.3612 6.46085 15.3612C6.74666 15.3612 6.97737 15.1305 6.97737 14.8447V11.112C6.97737 9.33173 8.42707 7.88203 10.2073 7.88203C11.9876 7.88203 13.4407 9.32828 13.4407 11.112Z"
      fill="#9999A7"
    />
    <path
      d="M20.7893 5.48886C22.301 5.48886 23.5338 4.25955 23.5338 2.74443C23.5338 1.23276 22.3044 0 20.7893 0C19.2742 0 18.0483 1.22931 18.0483 2.74443C18.0483 4.25611 19.2777 5.48886 20.7893 5.48886ZM20.7893 1.03304C21.7328 1.03304 22.5007 1.80093 22.5007 2.74443C22.5007 3.68794 21.7328 4.45583 20.7893 4.45583C19.8458 4.45583 19.0779 3.68794 19.0779 2.74443C19.0814 1.80093 19.8458 1.03304 20.7893 1.03304Z"
      fill="#9999A7"
    />
    <path
      d="M24.0228 11.112V14.8447C24.0228 15.1305 24.2535 15.3612 24.5393 15.3612C24.8251 15.3612 25.0558 15.1305 25.0558 14.8447V11.112C25.0558 8.76011 23.1412 6.849 20.7928 6.849C18.4444 6.849 16.5264 8.76011 16.5264 11.112V14.8447C16.5264 15.1305 16.7571 15.3612 17.0429 15.3612C17.3287 15.3612 17.5594 15.1305 17.5594 14.8447V11.112C17.5594 9.33173 19.0091 7.88203 20.7894 7.88203C22.5696 7.88203 24.0228 9.32828 24.0228 11.112Z"
      fill="#9999A7"
    />
  </svg>
);
const TeamMembersWrapper = ({ team_members }: any) => {
  const intl = useIntl();

  return (
    <>
      {/* <div className="flex gap-2">
        <span> {TeamSCGIcon("21.351px", "18px")} </span>
        <span className="font-semibold">تابع مبيعاتك مؤخراٌ</span>
      </div> */}
      {team_members?.length ? (
        <Component style={"!col-span-2 !m-0 !w-full"}>
          <TeamMembers team_members={team_members} />
        </Component>
      ) : (
        <div className="!col-span-2 !m-0">
          <EmptySection
            secondTitle={intl.formatMessage({
              id: "intl.form.teamMembersTitle",
            })}
            title={intl.formatMessage({ id: "intl.form.noStatsTitle" })}
            description={intl.formatMessage({
              id: "intl.form.noStatsDescription",
            })}
            icon={TeamSCGIcon()}
            paddingX="24px"
            paddingY="32px"
          />
        </div>
      )}
    </>
  );
};

export default TeamMembersWrapper;
